// removed by extract-text-webpack-plugin
module.exports = {"svg":"Spinner__svg-3hIqz","dash":"Spinner__dash-3ny3X","svgCircle":"Spinner__svgCircle-2_1ZC","rotate":"Spinner__rotate-2fJAe","opacity":"Spinner__opacity-QROd9"};